import { gql } from "graphql-request";
export const ARTICLES_GET_CATEGORY_BY_ID = gql`
    query articlesGetCategoryById($id: Int, $language: String!) {
        category(id: $id, isDeleted: false) {
            id
            name
            label
            slug
            languages
            isOneToOneConsent
            url(isActive: true, isDeleted: false, languageEq: $language) {
                isMain
                main {
                    url
                }
                url
            }
            metatags {
                key
                value
            }
            translations {
                key
                value
                language
            }
        }
    }
`;
